const allowedImageSizes = [
  // Icons: 16, 32, 48, 64, 96px
  16, 32, 48, 64, 96,
  // Thumbnails: 128, 192, 256px
  128, 192, 256,
  // Content Images: 320, 384, 450px
  320, 384, 450,
  // Video Posters: 480, 576, 640, 720, 800px
  480, 576, 640, 720, 800,
  // Hero Images: 960, 1024, 1200, 1440px
  960, 1024, 1200, 1440,
  // High-res: 1920, 2400, 2880, 3840px
  1920, 2400, 2880, 3840
];

/** 
 * @description Generate optimized image URL using Next.js Image Optimization API
 * 
 * @param {string} src - Original image source URL
 * @param {number} width - Desired image width
 * @param {number} quality - Desired image quality (1-100)
 * 
 * @returns {string|null} Optimized image URL or null if src is invalid
 */
const getOptimizedImageUrl = (src, width = 800, quality = 85) => {
  if (!src) return null;
  
  // If it's already an external URL or data URL, return as-is
  if (src.startsWith('http') || src.startsWith('data:') || process.env.NEXT_PUBLIC_PASSWORD_PROTECTION?.toUpperCase() === 'TRUE') {
    return src;
  }

  // Find the closest allowed size for width
  const closestWidth = allowedImageSizes.reduce((prev, curr) => {
    return (Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev);
  }, allowedImageSizes[0]);
  
  // Generate Next.js optimized image URL
  const params = new URLSearchParams({
    url: src.startsWith('/') ? src : `/${src}`,
    w: closestWidth.toString(),
    q: quality.toString(),
  });
  
  return `/_next/image?${params.toString()}`;
};

export default getOptimizedImageUrl;